import {Box, Stack, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const ServiceItemDashboard = ({type,color,icon,title, image, iconTitle, description}) => {
    const [flip, setFlip] = useState(false);
    const {mode} = useDarkMode();
    return (
        <div className="flip-card">
            <div className="flip-card-inner">
                <div className="flip-card-front">
                    <Box className={'advice_box'} onMouseEnter={()=> {setFlip(true);console.log('enter')}}
                         style={{backgroundColor : mode.settings.cardBackgroundColor}}
                    >
                        <Stack gap={1.5}>
                            <Stack className={'category_icon'} style={{background:color}} justifyContent={'center'}>
                                <Stack center direction={'row'} alignItems={"center"}>
                                    <img src={iconTitle}  alt=""/>
                                    <Typography color={'white'} variant={'subtitle2'} style={{marginLeft:10}}>{type}</Typography>
                                </Stack>
                            </Stack>
                            <Stack center alignItems={"center"}>
                                <img src={image} alt="" className={'image_advice_box'}/>
                            </Stack>
                            <Stack center alignItems={"center"}>
                                <Typography color={color} variant={"subtitle2"}>{title}</Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </div>
                <div className="flip-card-back" style={{backgroundColor : mode.settings.backgroundColor}}>
                    <Box className={'advice_box_detail'} style={{background:color}} onMouseLeave={() => {setFlip(false);console.log('exit')}}>
                        <Stack gap={1.5}>
                            <Stack className={'category_icon'} style={{background:'white'}} justifyContent={'center'}>
                                <Stack center direction={'row'} alignItems={"center"}>
                                    <img src={icon}  alt=""/>
                                    <Typography color={color} variant={'subtitle2'} style={{marginLeft:10}}>{type}</Typography>
                                </Stack>
                            </Stack>
                            <Stack center alignItems={"flex-start"}>
                                <Typography color={'white'} variant={"subtitle2"}>{title}</Typography>
                            </Stack>
                            <Stack center alignItems={"flex-start"}>
                                <Typography color={'white'} variant={"subtitle3"} sx={{textAlign :'left'}}>
                                    {description}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default ServiceItemDashboard;
